// footer.tsx
import React from "react"
import {Link} from "gatsby"
import SocialLinksNav from "./socialLinksNav"
import * as styles from "./footer.module.css"
import Section from "./section"
import {useIsRootPage} from "../hooks/useIsRootPage"

export default function Footer() {
	const isRootPage = useIsRootPage()

	return (
		<Section
			id="footer"
			className={styles.footer}
			wrapperClassName={styles.wrapper}
		>
			<ul className={styles.footerNav}>
				{!isRootPage && (
					<li>
						<Link to="/#contact">Contact</Link>
					</li>
				)}
				<li>
					<Link to="/idea-shower">Idea Shower Archive</Link>
				</li>
			</ul>
			<SocialLinksNav contextClassName={styles.socialLinksNav} />
			Copyright © {new Date().getFullYear()} Nate Weiner
		</Section>
	)
}
